import React, { useEffect, useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Shield, Award, Clock, Star, ChevronRight,Navigation,Plane,Search,Building, MapPin, Calendar, Clock as ClockIcon, Users, Car, Zap, Sparkles, CheckCircle, Phone, MessageCircle, ArrowRight,  } from 'lucide-react';
import HorizontalBookingForm from '../common/HorizontalBookingForm';
import reliableTransfer from '../Assets/ft1.jpg';
import transparentPricing from '../Assets/ft2.jpg';
import freeCancellation from '../Assets/ft3.jpg';
import heroDesktop from '../Assets/pexels-ian-panelo-20777853.jpg';
import heroMobile from '../Assets/pexels-ian-panelo-20777853.jpg';
import HeroImage from '../Assets/banner_bg.png'
import Image1 from '../Assets/banner-5.jpg'
import Image2 from '../Assets/banner-51.jpg'
import Features from '../home/Features'
import Driversection from '../home/DriverSection'
import Testimonials from '../home/Testimonials';
import VehiclesTypes from '../home/VehicleTypes ';
import exportHeroImage from '../Assets/banner_bg.png'
import mobileheroimage from '../Assets/high-angle-view-stylish-young-couple-using-digital-tablet-in-taxi.jpg'
import CabServices from '../home/CabServices'
import CityCoverage from '../home/CityCoverage'
import { useNavigate } from 'react-router-dom';
import hatch from "../Assets/mazda-3-hatchback.jpg"
const features = [
  {
    icon: Shield,
    title: "Reliable Transfers",
    description: "Plan outstation journeys or head to the airport, hassle-free. Pre-book with us for peace of mind and guaranteed dependability.",
    gradient: "from-yellow-400 via-yellow-400 to-yellow-600",
    bgColor: "bg-blue-500",
    benefits: ["24/7 Availability", "Professional Drivers", "GPS Tracking"]
  },
  {
    icon: Award,
    title: "Transparent Pricing",
    description: "With all-inclusive quotes (tolls, taxes) upfront, you always know what you're paying - zero surprises, just smooth rides.",
    gradient: "from-yellow-400 via-yellow-400 to-yellow-600",
    bgColor: "bg-blue-500",
    benefits: ["No Hidden Charges", "All Taxes Included", "Upfront Quotes"]
  },
  {
    icon: Clock,
    title: "Free Cancellation",
    description: "Plans change. Cancel free up to 24 hours before your trip—applies to every ride. Flexibility, guaranteed.",
    gradient: "from-yellow-400 via-yellow-400 to-yellow-600",
    bgColor: "bg-amber-500",
    benefits: ["24hr Free Cancellation", "Instant Refunds", "No Questions Asked"]
  }
];

const stats = [
  { number: "50K+", label: "Happy Customers", icon: Users, color: "text-blue-600", bg: "bg-blue-50" },
  { number: "2M+", label: "Miles Covered", icon: MapPin, color: "text-emerald-600", bg: "bg-emerald-50" },
  { number: "4.9★", label: "Customer Rating", icon: Star, color: "text-amber-600", bg: "bg-amber-50" },
  { number: "24/7", label: "Support", icon: Zap, color: "text-purple-600", bg: "bg-purple-50" }
];

const serviceAreas = [
  "Airport Transfers",
  "City Rides",
  "Outstation Trips",
  "Corporate Travel",
  "Event Transportation",
  "Hourly Rentals"
];

const ImageSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const images = [
    HeroImage,
    Image1, 
    Image2
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="relative w-full h-full overflow-hidden">
      <div 
        className="flex h-full transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {images.map((image, index) => (
          <div
            key={index}
            className="w-full h-full flex-shrink-0 relative"
          >
            <div 
              className="absolute inset-0 bg-cover bg-center bg-no-repeat"
              style={{ backgroundImage: `url(${image})` }}
            />
            <div className="absolute inset-0 bg-black/30"></div>
          </div>
        ))}
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
        {images.map((_, index) => (
          <button
            key={index}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentSlide ? 'bg-white scale-110' : 'bg-white/50'
            }`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>

      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white text-3xl bg-black/40 hover:bg-black/60 rounded-full w-12 h-12 flex items-center justify-center transition-all duration-300 z-20 backdrop-blur-sm"
      >
        ‹
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white text-3xl bg-black/40 hover:bg-black/60 rounded-full w-12 h-12 flex items-center justify-center transition-all duration-300 z-20 backdrop-blur-sm"
      >
        ›
      </button>
    </div>
  );
};

// Fixed HorizontalBookingForm component
// Fixed HorizontalBookingForm component
const FixedHorizontalBookingForm = ({ onSubmit }) => {
  const [activeService, setActiveService] = useState('outstation');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    pickupLocation: '',
    dropLocation: '',
    city: '',
    tripType: '',
    terminal: '',
    pickupDate: '',
    returnDate: '',
    pickupTime: '',
    mobileNumber: '',
    rentalPackage: '',
    vehicleType: '' // New field for vehicle type
  });

  const services = [
    { id: 'outstation', label: 'Outstation', icon: Navigation, color: 'blue' },
    { id: 'rental', label: 'Rental', icon: Car, color: 'green' },
    { id: 'airport', label: 'Airport', icon: Plane, color: 'purple' },
    { id: 'city', label: 'City', icon: Building, color: 'orange' }
  ];

  const cities = ['Bangalore', 'Chennai', 'Mumbai', 'Delhi', 'Hyderabad', 'Pune', 'Kolkata'];
  const terminals = ['Terminal 1', 'Terminal 2', 'Domestic', 'International'];
  const tripTypes = ['Pick-Up', 'Drop', 'Round Trip'];
  const rentalPackages = ['8hr/80km', '12hr/120km', '24hr/240km'];
  
  // New vehicle types array
  const vehicleTypes = [
    'Innova Hybrid Hy Cross',
    'Innova Crysta',
    'Maruti Ertiga Suv',
    'Toyota Rumion Suv',
    'Kia Carens Suv',
    'Maruti Ciaz',
    'Swift Dzire',
    'Toyota Etios',
    'Toyota Fortuner',
    'Force Urbania',
    'Tempo Traveller',
    'Bus'
  ];

  const timeSlots = [
    "12:00 AM", "12:30 AM", "1:00 AM", "1:30 AM", "2:00 AM", "2:30 AM", 
    "3:00 AM", "3:30 AM", "4:00 AM", "4:30 AM", "5:00 AM", "5:30 AM",
    "6:00 AM", "6:30 AM", "7:00 AM", "7:30 AM", "8:00 AM", "8:30 AM",
    "9:00 AM", "9:30 AM", "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM",
    "12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", "2:00 PM", "2:30 PM",
    "3:00 PM", "3:30 PM", "4:00 PM", "4:30 PM", "5:00 PM", "5:30 PM",
    "6:00 PM", "6:30 PM", "7:00 PM", "7:30 PM", "8:00 PM", "8:30 PM",
    "9:00 PM", "9:30 PM", "10:00 PM", "10:30 PM", "11:00 PM", "11:30 PM"
  ];

  // Fixed handleInputChange with proper state update
  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    
    if (name === 'mobileNumber') {
      const numbersOnly = value.replace(/\D/g, '');
      if (numbersOnly.length <= 10) {
        setFormData(prev => ({ 
          ...prev, 
          [name]: numbersOnly 
        }));
      }
    } else {
      setFormData(prev => ({ 
        ...prev, 
        [name]: value 
      }));
    }
  }, []);

  const handleServiceChange = (serviceId) => {
    setActiveService(serviceId);
    setFormData({
      pickupLocation: '',
      dropLocation: '',
      city: '',
      tripType: '',
      terminal: '',
      pickupDate: '',
      returnDate: '',
      pickupTime: '',
      mobileNumber: '',
      rentalPackage: '',
      vehicleType: '' // Reset vehicle type when service changes
    });
  };

  const generateBookingId = () => {
    const timestamp = new Date().getTime();
    const randomNum = Math.floor(Math.random() * 100);
    return `MyJourneyCabs${randomNum.toString().padStart(2, '0')}`;
  };

  const sendBookingToAdminWhatsApp = (bookingData) => {
    const adminWhatsAppNumber = '919467855781';
    
    // Generate booking ID if not provided
    const bookingId = bookingData.bookingId || generateBookingId();
    
    let serviceDetails = '';
    
    switch(bookingData.serviceType) {
      case 'outstation':
        serviceDetails = ` *Outstation Booking*
From: ${bookingData.pickupLocation}
To: ${bookingData.dropLocation}
Pickup Date: ${bookingData.pickupDate}
Return Date: ${bookingData.returnDate}`;
        break;
        
      case 'rental':
        serviceDetails = ` *Rental Booking*
City: ${bookingData.city}
Package: ${bookingData.rentalPackage}
Pickup Location: ${bookingData.pickupLocation}
Pickup Date: ${bookingData.pickupDate}`;
        break;
        
      case 'airport':
        serviceDetails = ` *Airport Booking*
Trip Type: ${bookingData.tripType}
Terminal: ${bookingData.terminal}
${bookingData.tripType === 'Pick-Up' ? 'Drop Address' : 'Pickup Address'}: ${bookingData.tripType === 'Pick-Up' ? bookingData.dropLocation : bookingData.pickupLocation}`;
        break;
        
      case 'city':
        serviceDetails = ` *City Ride*
From: ${bookingData.pickupLocation}
To: ${bookingData.dropLocation}
Date: ${bookingData.pickupDate}
Time: ${bookingData.pickupTime}`;
        break;
    }

    // Add vehicle type to the message
    const vehicleInfo = bookingData.vehicleType ? `*Preferred Vehicle:* ${bookingData.vehicleType}` : '*Preferred Vehicle:* Not specified';

    const message = ` *NEW CAB BOOKING REQUEST* 

*Booking ID:* ${bookingId}
*Service Type:* ${bookingData.serviceType.toUpperCase()}
*Mobile Number:* ${bookingData.mobileNumber}
${vehicleInfo}
*Booking Time:* ${new Date().toLocaleString()}

${serviceDetails}

*Additional Details:*
• Pickup Time: ${bookingData.pickupTime || 'Not specified'}

---
*Please contact the customer immediately to confirm the booking.*`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${adminWhatsAppNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
    
    // Return the booking ID so you can use it elsewhere
    return bookingId;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.mobileNumber || formData.mobileNumber.length !== 10) {
      alert('Please enter a valid 10-digit mobile number');
      return;
    }

    const bookingData = {
      ...formData,
      serviceType: activeService,
      submittedAt: new Date().toISOString()
    };

    try {
      setIsSubmitting(true);

      // Call original onSubmit if provided
      if (onSubmit) {
        onSubmit(bookingData);
      }

      // Send to admin via WhatsApp
      sendBookingToAdminWhatsApp(bookingData);

      // Refresh page immediately
      window.location.reload();

    } catch (error) {
      console.error('Error submitting booking:', error);
      alert('There was an error submitting your booking. Please try again.');
      setIsSubmitting(false);
    }
  };

  // Update your submit button to show loading state
  const SubmitButton = () => (
    <button
      type="submit"
      disabled={isSubmitting}
      className="w-full bg-gradient-to-r from-gray-900 to-gray-900 hover:from-yellow-500 hover:to-yellow-500 text-white py-3 rounded-lg font-bold text-sm transition-all duration-300 flex items-center justify-center gap-2 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
    >
      {isSubmitting ? (
        <>
          <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
          Sending...
        </>
      ) : (
        <>
          <Search className="h-4 w-4" />
          Search Available Cabs
          <ArrowRight className="h-4 w-4" />
        </>
      )}
    </button>
  );

  // Properly memoized InputField component outside of render
  const InputField = useCallback(({ 
    icon: Icon, 
    type = "text", 
    value, 
    onChange, 
    placeholder, 
    name, 
    required = false, 
    options = [],
    isCombobox = false // New prop for combobox
  }) => (
    <div className="relative">
      {Icon && <Icon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-500" />}
      {type === "select" ? (
        <select
          name={name}
          value={value || ''}
          onChange={onChange}
          className={`w-full p-3 ${Icon ? 'pl-10' : 'pl-3'} border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-sm transition-all duration-200 hover:border-gray-400`}
          required={required}
        >
          <option value="">{placeholder}</option>
          {options.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      ) : type === "date" ? (
        <input
          type="date"
          name={name}
          value={value || ''}
          onChange={onChange}
          min={new Date().toISOString().split('T')[0]}
          className={`w-full p-3 ${Icon ? 'pl-10' : 'pl-3'} border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-sm transition-all duration-200 hover:border-gray-400`}
          required={required}
        />
      ) : isCombobox ? (
        // Combobox for city with both input and dropdown
        <>
          <input
            list={`${name}-options`}
            name={name}
            value={value || ''}
            onChange={onChange}
            placeholder={placeholder}
            className={`w-full p-3 ${Icon ? 'pl-10' : 'pl-3'} border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-sm transition-all duration-200 hover:border-gray-400`}
            required={required}
          />
          <datalist id={`${name}-options`}>
            {options.map(option => (
              <option key={option} value={option} />
            ))}
          </datalist>
        </>
      ) : (
        <input
          type={type}
          name={name}
          value={value || ''}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full p-3 ${Icon ? 'pl-10' : 'pl-3'} border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-sm transition-all duration-200 hover:border-gray-400`}
          required={required}
          maxLength={name === 'mobileNumber' ? 10 : undefined}
        />
      )}
    </div>
  ), []);

  const renderFormFields = () => {
    switch (activeService) {
      case 'outstation':
        return (
          <div className="space-y-3">
            <InputField 
              icon={MapPin} 
              value={formData.pickupLocation} 
              onChange={handleInputChange} 
              placeholder="From city" 
              name="pickupLocation" 
              required 
            />
            <InputField 
              icon={MapPin} 
              value={formData.dropLocation} 
              onChange={handleInputChange} 
              placeholder="To city" 
              name="dropLocation" 
              required 
            />
            <div className="grid grid-cols-2 gap-3">
              <InputField 
                icon={Calendar} 
                type="date" 
                value={formData.pickupDate} 
                onChange={handleInputChange} 
                name="pickupDate" 
                required 
              />
              <InputField 
                icon={Calendar} 
                type="date" 
                value={formData.returnDate} 
                onChange={handleInputChange} 
                name="returnDate" 
                required 
              />
            </div>
          </div>
        );

      case 'rental':
        return (
          <div className="space-y-3">
            <InputField 
              icon={MapPin} 
              type="text" 
              value={formData.city} 
              onChange={handleInputChange} 
              placeholder="Enter city name" 
              name="city" 
              options={cities}
              isCombobox={true}
              required 
            />
            <InputField 
              type="select" 
              value={formData.rentalPackage} 
              onChange={handleInputChange} 
              placeholder="Select package" 
              name="rentalPackage" 
              options={rentalPackages} 
              required 
            />
            <InputField 
              icon={MapPin} 
              value={formData.pickupLocation} 
              onChange={handleInputChange} 
              placeholder="Pickup location" 
              name="pickupLocation" 
              required 
            />
            <InputField 
              icon={Calendar} 
              type="date" 
              value={formData.pickupDate} 
              onChange={handleInputChange} 
              name="pickupDate" 
              required 
            />
          </div>
        );

      case 'airport':
        return (
          <div className="space-y-3">
            <div className="bg-gray-50 p-3 rounded-lg border border-gray-200">
              <div className="text-xs text-gray-500 font-medium">City</div>
              <div className="text-sm font-semibold text-gray-800">Bangalore</div>
            </div>
            <InputField 
              icon={Navigation} 
              type="select" 
              value={formData.tripType} 
              onChange={handleInputChange} 
              placeholder="Trip type" 
              name="tripType" 
              options={tripTypes} 
              required 
            />
            <InputField 
              type="select" 
              value={formData.terminal} 
              onChange={handleInputChange} 
              placeholder="Select terminal" 
              name="terminal" 
              options={terminals} 
            />
            <InputField 
              icon={MapPin} 
              value={formData.tripType === 'Pick-Up' ? formData.dropLocation : formData.pickupLocation} 
              onChange={handleInputChange}
              placeholder={formData.tripType === 'Pick-Up' ? 'Drop address' : 'Pickup address'}
              name={formData.tripType === 'Pick-Up' ? 'dropLocation' : 'pickupLocation'}
              required
            />
          </div>
        );

      case 'city':
        return (
          <div className="space-y-3">
            <InputField 
              icon={MapPin} 
              value={formData.pickupLocation} 
              onChange={handleInputChange} 
              placeholder="From location" 
              name="pickupLocation" 
              required 
            />
            <InputField 
              icon={MapPin} 
              value={formData.dropLocation} 
              onChange={handleInputChange} 
              placeholder="To location" 
              name="dropLocation" 
              required 
            />
            <div className="grid grid-cols-2 gap-3">
              <InputField 
                icon={Calendar} 
                type="date" 
                value={formData.pickupDate} 
                onChange={handleInputChange} 
                name="pickupDate" 
                required 
              />
              <InputField 
                icon={Clock} 
                type="select" 
                value={formData.pickupTime} 
                onChange={handleInputChange} 
                placeholder="Time" 
                name="pickupTime" 
                options={timeSlots} 
              />
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  const getColorClasses = (service) => {
    const colorMap = {
      blue: { active: 'bg-blue-50 text-blue-700 border-blue-200', inactive: 'text-gray-600 hover:text-blue-600 hover:bg-blue-25' },
      green: { active: 'bg-green-50 text-green-700 border-green-200', inactive: 'text-gray-600 hover:text-green-600 hover:bg-green-25' },
      purple: { active: 'bg-purple-50 text-purple-700 border-purple-200', inactive: 'text-gray-600 hover:text-purple-600 hover:bg-purple-25' },
      orange: { active: 'bg-orange-50 text-orange-700 border-orange-200', inactive: 'text-gray-600 hover:text-orange-600 hover:bg-orange-25' }
    };
    return colorMap[service.color];
  };

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200/60 max-w-md mx-auto backdrop-blur-sm overflow-hidden">
      <div className="bg-gradient-to-r from-yellow-400 to-yellow-400 p-4">
        <h2 className="text-lg font-bold text-white text-center">Book Your Premium Ride</h2>
        <p className="text-blue-100 text-xs text-center mt-1">Fast, reliable, and comfortable journeys</p>
      </div>

      <div className="border-b border-gray-200 bg-gray-50/50">
        <div className="grid grid-cols-4 gap-1 p-2">
          {services.map((service) => {
            const IconComponent = service.icon;
            const isActive = activeService === service.id;
            const colors = getColorClasses(service);
            
            return (
              <button
                key={service.id}
                type="button"
                className={`flex flex-col items-center p-2 rounded-lg transition-all duration-300 ${
                  isActive 
                    ? `${colors.active} shadow-sm border` 
                    : `${colors.inactive} border border-transparent hover:border-gray-200`
                }`}
                onClick={() => handleServiceChange(service.id)}
              >
                <IconComponent className={`h-4 w-4 mb-1 ${isActive ? 'scale-110' : ''} transition-transform duration-300`} />
                <span className="text-xs font-semibold">{service.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="p-4">
        <form onSubmit={handleSubmit} className="space-y-4">
          {renderFormFields()}

          {/* New Vehicle Type Selection Field */}
          <InputField 
            icon={Car} 
            type="select" 
            value={formData.vehicleType} 
            onChange={handleInputChange} 
            placeholder="Select vehicle" 
            name="vehicleType" 
            options={vehicleTypes} 
          />

          <div className="space-y-3">
            <InputField 
              icon={Clock} 
              type="select" 
              value={formData.pickupTime} 
              onChange={handleInputChange} 
              placeholder="Pickup time" 
              name="pickupTime" 
              options={timeSlots} 
            />
            
            <InputField 
              icon={Phone} 
              type="tel" 
              value={formData.mobileNumber} 
              onChange={handleInputChange} 
              placeholder="Mobile number" 
              name="mobileNumber" 
              required 
            />

            <SubmitButton />
          </div>
        </form>

        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="grid grid-cols-3 gap-3 text-center">
            <div className="flex flex-col items-center">
              <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mb-1">
                <Car className="h-3 w-3 text-green-600" />
              </div>
              <span className="text-xs text-gray-600 font-medium">Safe Rides</span>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mb-1">
                <Clock className="h-3 w-3 text-blue-600" />
              </div>
              <span className="text-xs text-gray-600 font-medium">On Time</span>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mb-1">
                <Phone className="h-3 w-3 text-purple-600" />
              </div>
              <span className="text-xs text-gray-600 font-medium">24/7 Support</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const HomePage = ({ onNavigate }) => {
  const [bookingData, setBookingData] = useState(null);
  const [hoveredFeature, setHoveredFeature] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  const handleclick=()=>{
    navigate('/booking-form');
  }
  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);

    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  const handleBookingSubmit = (formData) => {
    setBookingData(formData);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 40, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };

  return (
    <div className="min-h-screen bg-white text-gray-900 overflow-hidden">
    <section className="relative min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 pt-20 lg:pt-25">
  {/* Single Background Layer - Fixed */}
  <div className="absolute inset-0 z-0 overflow-hidden">
    {isMobile ? (
      // Mobile Background
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-800 to-black">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,rgba(250,204,21,0.12),transparent_50%)]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_70%,rgba(59,130,246,0.08),transparent_50%)]"></div>
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:50px_50px]"></div>
        </div>
      </div>
    ) : (
      // Desktop Background with Image
      <div className="absolute inset-0">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ 
            backgroundImage: `url(${exportHeroImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
        {/* Dark Overlay for Better Text Readability */}
        <div className="absolute inset-0 bg-black/50"></div>
        {/* Additional Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/60"></div>
      </div>
    )}
  </div>

  {/* Animated Gradient Orbs - Desktop Only */}
  {!isMobile && (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <motion.div 
        className="absolute -top-40 -left-40 w-96 h-96 bg-gradient-to-br from-blue-200/20 to-cyan-200/20 rounded-full blur-3xl"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.3, 0.5, 0.3],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      <motion.div 
        className="absolute top-1/4 -right-40 w-96 h-96 bg-gradient-to-br from-violet-200/15 to-purple-200/15 rounded-full blur-3xl"
        animate={{
          scale: [1.2, 1, 1.2],
          opacity: [0.4, 0.2, 0.4],
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      <motion.div 
        className="absolute bottom-20 left-1/4 w-80 h-80 bg-gradient-to-br from-amber-200/15 to-orange-200/15 rounded-full blur-3xl"
        animate={{
          scale: [1, 1.3, 1],
          opacity: [0.2, 0.4, 0.2],
        }}
        transition={{
          duration: 7,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      
      {/* Subtle grid pattern overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:72px_72px] [mask-image:radial-gradient(ellipse_80%_60%_at_50%_50%,black,transparent)]" />
    </div>
  )}

  <div className="relative max-w-7xl mx-auto w-full">
    <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      {/* Content Section */}
      <motion.div
        className="text-left z-10"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {isMobile ? (
          <>
            {/* Mobile Hero Content */}
            <motion.div variants={itemVariants} className="text-center mb-2">
              <div className="inline-flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/20 rounded-full px-4 py-2 mb-6">
                <Sparkles className="w-4 h-4 text-yellow-400" />
                <span className="text-xs font-semibold text-yellow-400 uppercase tracking-wide">Premium Service</span>
              </div>
              
              <h1 className="text-4xl sm:text-5xl font-bold leading-[1.1] mb-4">
                <span className="inline-block bg-gradient-to-r from-white via-gray-100 to-white bg-clip-text text-transparent">
                  Premium Rides
                </span>
                <br />
                <span className="inline-block bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-400 bg-clip-text text-transparent mt-2">
                  Anytime, Anywhere
                </span>
              </h1>
              
              <p className="text-base text-gray-300 max-w-md mx-auto leading-relaxed">
                Experience luxury transportation with <span className="font-semibold text-yellow-300">professional drivers</span> and modern fleet
              </p>
            </motion.div>
          </>
        ) : (
          <>
            {/* Desktop Hero Content */}
            <motion.div variants={itemVariants}>
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mt-6 leading-[1.1]">
                <span className="inline-block text-gray-900">
                  Premium Rides,
                </span>
                <br />
                <span className="inline-block bg-gradient-to-r from-yellow-400 to-amber-400 bg-clip-text text-transparent mt-2">
                  Anytime, Anywhere
                </span>
              </h1>
            </motion.div>

            <motion.p
              variants={itemVariants}
              className="text-lg sm:text-xl text-gray-900 mt-8 max-w-xl leading-relaxed"
            >

Instant cab booking with <span className="font-semibold text-yellow-300">transparent pricing,</span> verified drivers, and 24/7 service. Whether it’s a business meeting or a weekend getaway — your perfect ride is just a click away.                    
            </motion.p>

            <motion.div
              variants={itemVariants}
              className="flex flex-col sm:flex-row gap-4 mb-8 mt-8"
            >
              <motion.button
                onClick={handleclick}
                whileHover={{ scale: 1.03, y: -2 }}
                whileTap={{ scale: 0.98 }}
                className="group relative bg-gradient-to-r from-yellow-500 to-yellow-600 text-white px-8 py-4 rounded-2xl font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 overflow-hidden"
              >
                <span className="relative z-10 flex items-center justify-center gap-3">
                  <Car className="w-5 h-5" />
                  Book Your Ride
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-yellow-600 to-amber-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </motion.button>
              
              <motion.button
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.98 }}
                className="group bg-white/20 bg-gradient-to-r from-gray-900 to-gray-900  text-white px-8 py-4 rounded-2xl font-semibold text-lg hover:bg-white/30 hover:border-white/50 transition-all duration-300 flex items-center justify-center gap-3 shadow-lg"
              >
                <Phone className="w-5 h-5 group-hover:rotate-12 transition-transform" />
                Call Now
              </motion.button>
            </motion.div>

            <motion.div
              variants={itemVariants}
              className="mb-10"
            >
              <p className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">Our Services</p>
              <div className="flex flex-wrap gap-3">
                {serviceAreas.map((area, index) => (
                  <motion.span
                    key={area}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.6 + index * 0.1 }}
                    className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 text-sm font-medium text-gray-900 hover:bg-white/30 hover:shadow-md transition-all duration-200"
                  >
                    <CheckCircle className="w-3.5 h-3.5 text-green-600" />
                    {area}
                  </motion.span>
                ))}
              </div>
            </motion.div>
          </>
        )}
      </motion.div>

      {/* Booking Form Section */}
      <motion.div
        className="relative"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.3 }}
      >
        <FixedHorizontalBookingForm onSubmit={handleBookingSubmit} />
      </motion.div>
    </div>
  </div>

  {/* Scroll Indicator - Desktop Only */}
  {!isMobile && (
    <motion.div
      className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20"
      animate={{ y: [0, 10, 0] }}
      transition={{ duration: 2, repeat: Infinity }}
    >
      <div className="flex flex-col items-center gap-2">
        <div className="text-white text-sm opacity-70">Scroll to explore</div>
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <motion.div
            className="w-1 h-3 bg-white rounded-full mt-2"
            animate={{ y: [0, 16, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          />
        </div>
      </div>
    </motion.div>
  )}
</section>

      <div>
        <VehiclesTypes/>
      </div>

      <Features />

      <section className="relative py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-transparent to-slate-900/50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
               Service Quality
            </h2>
            <p className="text-xl text-gray-700 max-w-2xl mx-auto">
              We're committed to providing you with the best transportation experience
            </p>
          </div>
     
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={feature.title}
                  className="group relative bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl rounded-3xl border border-white/20 overflow-hidden transition-all duration-500 hover:-translate-y-4 hover:shadow-2xl hover:shadow-blue-500/20 cursor-pointer"
                  onMouseEnter={() => setHoveredFeature(index)}
                  onMouseLeave={() => setHoveredFeature(null)}
                >
                  <div className={`absolute inset-0 bg-gradient-to-br ${feature.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-500`} />
                  
                  <div className={`bg-gradient-to-r ${feature.gradient} p-6 relative overflow-hidden`}>
                    <div className="flex items-center justify-between relative z-10">
                      <div className="w-14 h-14 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                        <Icon className="h-7 w-7 text-white" />
                      </div>
                      <div className="text-3xl font-black text-white/30 group-hover:text-white/50 transition-colors">
                        0{index + 1}
                      </div>
                    </div>
                    <div className="absolute -right-10 -top-10 w-40 h-40 bg-white/10 rounded-full group-hover:scale-150 transition-transform duration-700" />
                  </div>

                  <div className="p-6 relative">
                    <h3 className="text-2xl font-bold text-gray-500 mb-3 group-gray:text-blue-300 transition-colors">
                      {feature.title}
                    </h3>
                    <p className="text-gray-500 leading-relaxed mb-6">
                      {feature.description}
                    </p>
                    
                    <div className="space-y-3">
                      {feature.benefits.map((benefit, idx) => (
                        <div 
                          key={benefit} 
                          className="flex items-center gap-3 text-sm text-gray-800 transform translate-x-0 group-hover:translate-x-2 transition-transform"
                          style={{ transitionDelay: `${idx * 0.1}s` }}
                        >
                          <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
                          {benefit}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 pointer-events-none" />
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <div>
        <Driversection />
      </div>

      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-yellow-400 via-yellow-400 to-yellow-400">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              className="text-left"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-gray-900 px-4 py-2 rounded-full text-sm font-semibold mb-6 border border-white/30">
                <Zap className="w-4 h-4" />
                Get 10% Off Your First Ride
              </div>
              
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Ready to Experience Premium Travel?
              </h2>
              
              <p className="text-xl text-gray-560 mb-8 leading-relaxed">
                Join thousands of satisfied customers who trust us for their transportation needs. Book now and travel with confidence.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <motion.button
                 onClick={handleclick}
                  whileHover={{ scale: 1.02, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                  className="bg-gray-900 text-gray-100 px-8 py-4 rounded-2xl font-bold text-lg shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center gap-3 group"
                >
                  <Car className="w-5 h-5" />
                  Book Your Ride
                  <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
                </motion.button>
                
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="border-2 border-white/40 text-white px-8 py-4 rounded-2xl font-semibold text-lg hover:bg-white/10 backdrop-blur-sm transition-all duration-300 flex items-center justify-center gap-3"
                >
                  <Phone className="w-5 h-5" />
                  Call Us Now
                </motion.button>
              </div>
            </motion.div>

            <motion.div
              className="grid grid-cols-2 gap-6"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              {[
                { label: "Safe & Secure", value: "100%" },
                { label: "On-time Arrival", value: "98%" },
                { label: "Customer Satisfaction", value: "99%" },
                { label: "Ride Completion", value: "100%" }
              ].map((item) => (
                <motion.div 
                  key={item.label} 
                  className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-colors"
                  whileHover={{ scale: 1.05 }}
                >
                  <div className="text-3xl font-bold text-white mb-2">{item.value}</div>
                  <div className="text-blue-50 text-sm font-medium">{item.label}</div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

     

      <div>
        <Testimonials />
      </div>

      <div>
      <CityCoverage/>
     </div>

       <div>
        <CabServices/>
      </div>
    </div>
  );
};

export default HomePage;